module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar3-range-c900eb51.svg";